export class State {
    error = null;
    success = false;
    isLoading = false;
    dataList = [];
    total = 0;
}
